export const enum UserRole {
  Admin = 'admin',
  Staff = 'staff',
  Parent = 'parent',
  Student = 'student',
}
